module.exports = __webpack_public_path__ + "static/media/document-week2.f4f85e45.pdf";